export {
  compressText,
  decodeCompressedJson,
  decodeStrokePoints,
  decompressText,
  encodeStrokePoints,
  type DecodeCompressedJsonDiagnostics,
} from '../shared/url-codec.js';

export function clearUrlHash() {
  return replaceUrlState(`${window.location.origin}${window.location.pathname}${window.location.search}`);
}

export function setUrlHash(hash: string) {
  return replaceUrlState(`${window.location.origin}${window.location.pathname}${window.location.search}#${hash}`);
}

export function replaceUrlState(url: string) {
  if (new URL(url, window.location.href).href === window.location.href) return true;
  try {
    history.replaceState(null, '', url);
    return true;
  } catch (error: any) {
    if (error?.name === 'SecurityError') return false;
    throw error;
  }
}

export function consumeSessionHashDraft(storageKey: string, { errorMessage = 'Failed to restore navigation draft:' } = {}) {
  try {
    const hash = sessionStorage.getItem(storageKey);
    sessionStorage.removeItem(storageKey);
    return hash || null;
  } catch (error) {
    console.error(errorMessage, error);
    return null;
  }
}

/** Keep an unfinished sharing task while changing to the saved map URL. */
export function retainSharingNavigation(path: string, currentHref: string): string {
  const current = new URL(currentHref);
  const target = new URL(path, current.origin);
  for (const key of ['open', 'share_map', 'share_section', 'share_task']) {
    const value = current.searchParams.get(key);
    if (value) target.searchParams.set(key, value);
  }
  return target.href;
}
